<template>
  <RoundButton
    class="play-button"
    @click.native="$emit('play')"
  />
</template>

<script>
import RoundButton from '@/components/RoundButton'

export default {
  name: 'PlayButton',
  components: {
    RoundButton
  }
}
</script>

<style lang="scss" scoped>
@keyframes pulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
    box-shadow: inset 0px 0px 25px 3px rgba(255, 255, 255, 0.3), 0px 0px 25px 10px rgba(255, 255, 255, 0.3);
  }

  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
    box-shadow: none;
  }
}

.play-button {
  &::after,
  &::before {
    content: '';
    position: absolute;
  }

  &::after {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-43%) translateY(-50%);
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 25px solid white;
    z-index: 100;
  }

  &::before {
    width: 100%;
    height: 100%;
    animation: pulse 2s infinite forwards;
    opacity: 1;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    border: 2px solid rgba(white, 0.2);
    transform: translate(-50%, -50%) scale(1);
    background: rgba(white, 0);
  }
}
</style>
